export default __webpack_public_path__ + "static/media/money_back_icon.6cd8092d.svg";